import { RCPOProductCard } from './ProductCard'
import { RCPOProductCardLoading } from './ProductCardLoading'
import { Article } from '@generated'
import React, { FC } from 'react'

type RCPOProductGridProps = {
  items: Article[]
  fetching: boolean
}

export const RCPOProductGrid: FC<RCPOProductGridProps> = ({ items, fetching }) => {
  const applicableItems = fetching ? Array.from({ length: 8 }) : items

  return (
    <div id="item-container">
      {applicableItems && applicableItems.length > 0 && (
        <div className="grid grid-cols-2 gap-4 md:grid-cols-6">
          {fetching
            ? applicableItems.map((_, index) => (
                <RCPOProductCardLoading isFirst={index === 0} isSecond={index === 1} key={index} />
              ))
            : applicableItems.map((item: any, index: number) => (
                <RCPOProductCard
                  isFirst={index === 0}
                  isSecond={index === 1}
                  key={item.id}
                  data={item}
                />
              ))}
        </div>
      )}
    </div>
  )
}
